import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionTopicMaster = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        sectionSyllabusStructureMasterId: '',
        sectionLessonMasterId: '',
        sectionTopicName: [''],
        instituteSubjectMasterId: ''
    }

    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [topicData, setTopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "sectionLessonMasterDetails.sectionLessonName", "sectionTopicName"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getTopicList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (topicData.sectionSyllabusStructureMasterId !== '' && topicData.instituteSubjectMasterId !== '') {
                setTopicList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(topicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(topicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > topicList.length) {
            endIndex = topicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(topicList.slice(startIndex, endIndex));
    }, [topicList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `get-section-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;

        if (topicData.sectionSyllabusStructureMasterId !== '') {
            apiUrl += `sectionSyllabusStructureMasterId=${topicData.sectionSyllabusStructureMasterId}&`;
        }

        if (topicData.sectionLessonMasterId !== '') {
            apiUrl += `sectionLessonMasterId=${topicData.sectionLessonMasterId}&`;
        }

        if (topicData.instituteSubjectMasterId !== '') {
            apiUrl += `instituteSubjectMasterId=${topicData.instituteSubjectMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        getTopicList();
    }, [topicData.instituteSubjectMasterId, topicData.sectionLessonMasterId]);

    const getTopicList = async () => {
        if (topicData.sectionSyllabusStructureMasterId !== '' && topicData.instituteSubjectMasterId !== '') {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl())
                setTopicList(response.data.result);
            } catch (error) {
                setTopicList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const handleInputChange = (e, index) => {
        setTopicData((prevData) => {
            if (e.target.name === 'sectionTopicName') {
                const updatedTopicName = [...prevData.sectionTopicName];
                updatedTopicName[index] = e.target.value;
                return {
                    ...prevData,
                    sectionTopicName: updatedTopicName,
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleAddTopic = () => {
        setTopicData((prevData) => ({
            ...prevData,
            sectionTopicName: [...prevData.sectionTopicName, ''],
        }));
    };

    const handleRemoveTopic = (index) => {
        setTopicData((prevData) => {
            const updatedTopicName = [...prevData.sectionTopicName];
            updatedTopicName.splice(index, 1);
            return {
                ...prevData,
                sectionTopicName: updatedTopicName,
            }
        });
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-section-syllabus-structure?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
                sectionLessonMasterId: ''
            }
        })

        const apiUrl = `/get-section-syllabus-structure-Wise-section-subjects?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                sectionLessonMasterId: ''
            }
        })
        const apiUrl2 = `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${topicData.sectionSyllabusStructureMasterId}&instituteSubjectMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        const noErrors = Object.values(error).every((error) => error === '');

        const allValuesValid = Object.entries(topicData).every(([key, value]) => {
            if (key === 'sectionTopicName' && Array.isArray(value)) {
                return value.every(topic => typeof topic === 'string' && topic.trim() !== '');
            } else {
                return typeof value === 'string' && value.trim() !== '';
            }
        });

        return noErrors && allValuesValid;
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(topicData)) {
                if (key === "sectionTopicName") {
                    for (const topic of topicData.sectionTopicName) {
                        if (topic == '' || topic.length == 0) {
                            setError((prevData) => ({
                                ...prevData,
                                sectionTopicName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [topicData])

    const addTopic = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-section-topic-master`;
                const response = await authorizedAxiosSection.post(apiUrl, topicData);
                await getTopicList();
                setTopicData((prevData) => {
                    return {
                        ...prevData,
                        sectionTopicName: [''],
                    }
                })

                setSaveId(response.data.result[0].id);
                setSyllabusStructureNameSort(null);
                setSubjectSort(null);
                setLessonNameSort(null);
                setTopicNameSort(null);
                setSearchValue(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(topicData)) {
                if (key === "sectionTopicName") {
                    for (const topic of topicData.sectionTopicName) {
                        if (topic == '' || topic.length == 0) {
                            setError((prevData) => ({
                                ...prevData,
                                sectionTopicName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value == '') {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteTopic = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-section-topic-master?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, topicList.length);
                await getTopicList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateTopic = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-section-topic-master?id=${editId}`;
            const response = await authorizedAxiosSection.put(apiUrl, topicData);
            await getTopicList();
            setEditId(null);
            setTopicData((prevData) => {
                return {
                    ...prevData,
                    sectionTopicName: [''],
                }
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    const handleInputReset = () => {
        setTopicList([]);
        setEditId('');
        setTopicData(initialFormState);
        setError(initialErrorState);
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setSyllabusStructureNameSort(null);
            setLessonNameSort(null);
            setSubjectSort(null);
        }
    }, [topicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Topic</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-hashtag"></i> Topic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionSyllabusStructureMasterId' onChange={handleSyllabusChange} value={topicData.sectionSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.sectionSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.sectionSyllabusStructureMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={topicData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionLessonMasterId' onChange={handleInputChange} value={topicData.sectionLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.sectionLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionLessonMasterId && <p style={{ color: 'red' }}>{error.sectionLessonMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                {topicData.sectionTopicName.map((topic, index) => (
                                                    <>
                                                        <div className="col-md-11">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Section Topic Name :</label>
                                                            <input type="text" className="form-control" id={`sectionTopicName${index}`} name='sectionTopicName' onChange={(e) => handleInputChange(e, index)} value={topic} />
                                                            {error.sectionTopicName && topic.length === 0 && <p style={{ color: 'red' }}>{error.sectionTopicName}</p>}
                                                        </div>
                                                        {topicData.sectionTopicName.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveTopic(index)} ><i className="material-icons" style={{ fontSize: '20px' }}>delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '220px' }} onClick={handleAddTopic}>+ Add Another Topic Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addTopic}>Save</button>
                                                    }
                                                    <button className="btn btn-outline-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateTopic} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Structure Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"sectionLessonMasterDetails.sectionLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"sectionTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((topic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{topic.sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName}</td>
                                                                                        <td>{topic.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{topic.sectionLessonMasterDetails?.sectionLessonName}</td>
                                                                                        <td>{topic.sectionTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setTopicData({
                                                                                                    sectionMasterId: sectionMasterId,
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    sectionSyllabusStructureMasterId: topic.sectionSyllabusStructureMasterDetails.id,
                                                                                                    sectionLessonMasterId: topic.sectionLessonMasterDetails.id,
                                                                                                    sectionTopicName: [topic.sectionTopicName],
                                                                                                    instituteSubjectMasterId: topic.instituteSubjectMasterDetails.id
                                                                                                });
                                                                                                setEditId(topic.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === topic.id} onClick={() => deleteTopic(topic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Topic Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={topicList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionTopicMaster;